import { type FC } from 'react';
import { FormField, MaskedTextInputCompact, type TestProps, usePriceMask } from '@direct-frontend/components';
import { useField, useFormInstance } from '@adv-frontend/form-kit';
import { MIN_AVAILABLE_PRICE, RUBBLE_SIGN } from '../../../../lib/constants';
import { changeVariantPriceTooltipForm } from '../../model';

type ManualDiscountPriceFieldProps = { formId: string; isSaving: boolean } & TestProps;

export const ManualDiscountPriceField: FC<ManualDiscountPriceFieldProps> = ({ formId, isSaving }) => {
    const formInstance = useFormInstance({ form: changeVariantPriceTooltipForm, id: formId });

    const field = useField(formInstance.fields.manualDiscountPrice);
    const fieldProps = field.getProps();

    const priceMaskConfig = usePriceMask({
        currencyText: RUBBLE_SIGN,
        min: MIN_AVAILABLE_PRICE,
        precision: 0,
    });

    return (
        <FormField>
            {(formFields) => (
                <MaskedTextInputCompact
                    {...formFields}
                    {...fieldProps}
                    maskConfig={priceMaskConfig}
                    isLoading={isSaving}
                    label="Цена со скидкой"
                    min={MIN_AVAILABLE_PRICE}
                    size="xs"
                />
            )}
        </FormField>
    );
};
